<template>
    <div class="success">
        <i-tooltip :disabled="!isBlankLayout">
            <img class="icon" :src="icon" @click="onIconClick" />
            <div slot="body">
                <div v-if="$route.query.msgSuccess">{{ $route.query.msgSuccess }}</div>
                <div v-else>{{ $t('msgSuccess') }}<br/><strong>{{ organizationName }}</strong></div>
            </div>
        </i-tooltip>

        <div class="message" v-if="$route.query.msgSuccess">{{ $route.query.msgSuccess }}</div>
        <div class="message" v-else>{{ $t('msgSuccess') }}<br/><strong>{{ organizationName }}</strong></div>

        <ul class="list -inline _margin-0">
            <li>
                <a @click="$store.dispatch('reset')">{{ $t('goBack') }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import StatusComponentMixin from "../../mixins/StatusComponentMixin";

export default {
    name: "Success",
    mixins: [
        StatusComponentMixin
    ],
    computed: {
        icon() {
            return this.$route.query.iconset === "thumbs" ? "/assets/thumbs-up.svg" : "/assets/success.svg";
        }
    }
};
</script>
